import Page from 'modules/Page';
import lazyWithSuspense from 'modules/lazyWithSuspense';
import makePage from 'modules/makePage';
import { i18n } from 'i18n';
import { DETAILS_ROUTE_PATH as dashboardPath } from 'modules/project/ProjectAreaPage/constants';
import withLicenceAndDisclaimer from '../withLicenceAndDisclaimer';
import * as constants from './constants';
import useCustomReportTemplatesPageQueries, { CustomReportTemplatesPageQueries } from './useCustomReportTemplatesPageQueries';

const CustomReportTemplatesPage = lazyWithSuspense(() => import('./CustomReportTemplatesPage'));

const page: Page<constants.CustomReportTemplatesPageParams> = {
  title: constants.TITLE,
  routeProps: {
    path: constants.ROUTE_PATH,
  },
  authorise: (context, params) => ({
    handler: context.functions.canViewTeam,
    teamId: params.projectId,
  }),
  component: withLicenceAndDisclaimer({
    Component: makePage<constants.CustomReportTemplatesPageParams, CustomReportTemplatesPageQueries>({
      WrappedPage: CustomReportTemplatesPage,
      titleFn: () => i18n._('Custom Reports'),
      parentPathTemplate: dashboardPath,
      parentTitleFn: () => i18n._('Dashboard'),
      pageDataHook: useCustomReportTemplatesPageQueries,
    }),
  }),
};

export default page;
